export default __webpack_public_path__ + "static/media/school-blue.75d3eaac.svg";